import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, InputGroupText, Label } from 'reactstrap'
import axiosInstance from '../../../../Utils/axiosInstance';
import { backendbaseUrl } from '../../../../Utils/baseUrl';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { P } from '../../../../AbstractElements';

function CompanyEditPage() {
    const { id } = useParams();
    const [formData, setFormData] = useState<{
        purchaserName: string,
        organizationName: string,
        email: string,
        phone: string,
        country: string,
        password: string,
        plan: string,
        defaultCurrency: string,
        planName: string

    }
    >({
        purchaserName: "",
        organizationName: "",
        email: "",
        phone: "",
        country: "",
        password: "",
        plan: "",
        defaultCurrency: "",
        planName: "",

    });

    const [countryOptions, SetCountryOptions] = useState([])
    const [currency, SetCurrency] = useState<any>([])
    const navigate = useNavigate();



    useEffect(() => {

        const fetchData = async () => {

            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/company/organization/${id}`)

                const data = response.data

                let details = {
                    purchaserName: data?.users?.name,
                    organizationName: data?.organization_details?.name,
                    email: data?.organization_details.email,
                    phone: data?.organization_details.phone_number,
                    country: data?.organization_details.default_country_code,

                    plan: data?.current_plan.plan_id,
                    defaultCurrency: data?.organization_details.default_currency_country_code,
                    planName: data?.current_plan.plan_name
                }

                setFormData(prevFormData => ({ ...prevFormData, ...details }));



            }
            catch (error: any) {
                if (error.response) {
                    if (error.response.status === 400) {
                        toast.error("Please fill every field");
                    } else {
                        toast.error(
                            error.response.data.message || "An unknown error occurred"
                        );
                    }
                } else {
                    toast.error("Network error or server is down");
                }
            }
        }

        fetchData()

    }, [])




    useEffect(() => {
        const getCountryList = async () => {

            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/settings/country/default-country/`);
                if (response.status === 200) {
                    const countryListData = response?.data?.map((c: any) => ({
                        value: c.country.id,
                        label: c.country.country_name
                    })) || [];

                    SetCountryOptions(countryListData)
                    SetCurrency(response.data)
                    formData.country = countryListData[0].value
                    formData.defaultCurrency = countryListData[0].value




                }

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {
                        toast.error("Unauthorized");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }

            }

        }

        getCountryList();



    }, []);









    const [plansList, setPlansList] = useState<any>([])

    useEffect(() => {
        const getPlanList = async () => {

            try {
                const response = await axiosInstance.get(`${backendbaseUrl}/plans/list/`)
                if (response.status === 200) {
                    const planListData = response?.data?.results?.map((c: any) => ({
                        value: c.id,
                        name: c.name,
                        max_users: c.max_users
                    }))

                    setPlansList(planListData)
                    formData.plan = planListData[0].value
                }




            }

            catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {
                        toast.error("Unauthorized");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }
            }



        }
        getPlanList()
    }, [])















    const defaultCurrency = currency.find((currency: { is_default: any; }) => currency.is_default) || currency[0];
    const [selectedCurrency, setSelectedCurrency] = useState(defaultCurrency?.country?.id || "");



    const [errors, setErrors] = useState<any>({});

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        let newErrors: any = {};
        if (!formData.organizationName) newErrors.organizationName = "This field is required";
        if (!formData.email) newErrors.email = "Valid email is required";
        if (!formData.phone) newErrors.phone = "Phone number is required";

        // if (!formData.password || formData.password.length < 6) newErrors.password = "Password must be at least 6 characters";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e: any) => {
        console.log("clicked");
        
        e.preventDefault();
        if (validateForm()) {

            const CreateCompany = async () => {
                try {
                    const response = await axiosInstance.patch(`${backendbaseUrl}/company/organization/update/${id}/`, {
                        "name": formData.organizationName,
                        "email": formData.email,
                        "phone_number": formData.phone,
                        "country": formData.country,
                        "default_currency": formData.defaultCurrency,
                        "plan": formData.plan,
                        "password": formData.password,
                        "purchaser_name": formData.purchaserName,
                        "organization_id": id



                    })
                    if (response.status === 200) {
                        toast.success("Company updated Successfully")
                        // setFormData({
                        //     purchaserName: "",
                        //     organizationName: "",
                        //     email: "",
                        //     phone: "",
                        //     country: "",
                        //     password: "",
                        //     plan: "",
                        //     defaultCurrency: "",
                        //     planName: ""
                        // })

                        navigate("/settings/company/list-register-company")
                    }

                }

                catch (error: any) {
                    if (error.response) {
                        if (error.response.status === 401) {
                            toast.error("Unauthorized");
                        } else if (error.response.data) {
                            const errorData = error.response.data;

                            if (typeof errorData === "object") {
                                Object.keys(errorData).forEach((key) => {
                                    toast.error(`${key}: ${errorData[key]}`);
                                });
                            } else {
                                toast.error(errorData || "An unknown error occurred");
                            }
                        } else {
                            toast.error("An unknown error occurred");
                        }
                    } else {
                        toast.error("Network error or server is down");
                    }
                }

            }

            CreateCompany()

        }
    };
    return (
        <div className='page-body'>
            <Container fluid>
                <Col sm={12}>
                    <Card>
                        <CardBody>
                            <h4 className="mb-4">Register Your Company</h4>
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <Label for="organizationName">Organization Name</Label>
                                    <Input type="text" id="organizationName" name="organizationName" value={formData.organizationName} onChange={handleChange} />
                                    {errors.organizationName && <span className="text-danger">{errors.organizationName}</span>}
                                </FormGroup>
                                {/* <FormGroup>
                                    <Label for="organizationName">Name of the Buyer</Label>
                                    <Input type="text" id="purchaserName" name="purchaserName" value={formData.purchaserName} onChange={handleChange} />
                                    {errors.purchaserName && <span className="text-danger">{errors.purchaserName}</span>}
                                </FormGroup> */}


                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input type="email" id="email" name="email" value={formData.email} onChange={handleChange} />
                                    {errors.email && <span className="text-danger">{errors.email}</span>}
                                </FormGroup>

                                <FormGroup>
                                    <Label for="phone">Phone</Label>
                                    <Input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} />
                                    {errors.phone && <span className="text-danger">{errors.phone}</span>}
                                </FormGroup>

                                <FormGroup>
                                    <Label for="country">Company Origin Country</Label>

                                    <InputGroupText>
                                        <select value={formData.country} name="country" onChange={handleChange} className="form-select">


                                            {currency.length > 0 ? (
                                                currency.map((currencyItem: any) => (
                                                    <option key={currencyItem?.country?.id} value={currencyItem?.country?.country_code} onChange={handleChange}>
                                                        {currencyItem?.currency_symbol} ({currencyItem?.country?.country_name || "Unknown"})
                                                    </option>
                                                ))
                                            ) : (
                                                <option disabled>No currencies available</option>
                                            )}

                                        </select>
                                    </InputGroupText>
                                </FormGroup>

                                <FormGroup>
                                    <Label for="country">Default Currency</Label>

                                    <InputGroupText>
                                        <select value={formData.defaultCurrency} name="defaultCurrency" onChange={handleChange} className="form-select">


                                            {currency.length > 0 ? (
                                                currency.map((currencyItem: any) => (
                                                    <option key={currencyItem?.country?.id} value={currencyItem?.country?.country_code} onChange={handleChange}>
                                                        {currencyItem?.currency_symbol} ({currencyItem?.country?.country_name || "Unknown"})
                                                    </option>
                                                ))
                                            ) : (
                                                <option disabled>No currencies available</option>
                                            )}

                                        </select>
                                    </InputGroupText>
                                </FormGroup>



                                <FormGroup>
                                    <Label for="country">Select Plan</Label>
                                    <InputGroupText>
                                        <select value={formData.plan} name="plan" onChange={handleChange} className="form-select">
                                            {plansList.length > 0 ? (
                                                [...plansList]
                                                    .sort((a, b) => {
                                                        if (a.name === formData.planName) return -1;
                                                        if (b.name === formData.planName) return 1;
                                                        return 0;
                                                    })
                                                    .map((planItem: any) => (
                                                        <option
                                                            key={planItem?.value}
                                                            value={planItem?.value}
                                                        >
                                                            {planItem?.name} ({planItem?.max_users || "Unknown"} Users)
                                                        </option>
                                                    ))
                                            ) : (
                                                <option disabled>No Plans available</option>
                                            )}
                                        </select>
                                    </InputGroupText>
                                </FormGroup>



                                {/* <FormGroup>
                            <Label for="country">Plans</Label>
                            <Input type="select" id="country" name="country" value={formData.country} onChange={handleChange}>
                                <option value="">Select Country</option>
                                <option value="USA">USA</option>
                                <option value="India">India</option>
                                <option value="UK">UK</option>
                            </Input>
                            {errors.country && <span className="text-danger">{errors.country}</span>}
                        </FormGroup> */}

                                {/* <FormGroup>
                                    <Label for="password">Password</Label>
                                    <Input type="password" id="password" name="password" value={formData.password} onChange={handleChange} />
                                    {errors.password && <span className="text-danger">{errors.password}</span>}
                                </FormGroup> */}

                                <Button color="primary" type="submit" onClick={handleSubmit}>Register</Button>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Container>
        </div>
    )
}

export default CompanyEditPage